const getters = {
  getStrategyTypeList(state) {
    return state.strategyTypes;
  },
};

export default getters;
